import { mutate } from 'swr';
import axios from 'axios';
import { Notistack } from '../../../../../../shared/components/Notistack/Notistack';
import { ITeamTypeType } from '../../interfaces';

const path = '/user-service/teamType';

export const requestCreateTeamType = (name: string) => {
  return mutate(path, async() => {
    try {
      await axios.post(path, { name });
      Notistack.successMessage('Team Type - Created Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};

export const requestUpdateTeamType = ({ id, name }: ITeamTypeType) => {
  return mutate(path, async() => {
    try {
      await axios.put(`${path}/${id}`, { name });
      Notistack.successMessage('Team Type - Updated Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};

export const requestDeleteTeamType = (id: string) => {
  return mutate(path, async() => {
    try {
      await axios.delete(`${path}/${id}`);
      Notistack.successMessage('Team Type - Deleted Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};
